import { Navigate } from 'react-router-dom';
import CreateDeal from 'routes/fundDeals/CreateDeal';
import BasicInformation from 'routes/fundDeals/CreateDeal/BasicInformation';
import CarryRecipients from 'routes/fundDeals/CreateDeal/CarryRecipients';
import CompanyInformation from 'routes/fundDeals/CreateDeal/CompanyInformation';
import DealUnderReview from 'routes/fundDeals/CreateDeal/DealUnderReview';
import ExternalInvestors from 'routes/fundDeals/CreateDeal/ExternalInvestors';
import Memo from 'routes/fundDeals/CreateDeal/Memo';
import RisksDisclosures from 'routes/fundDeals/CreateDeal/RiskDisclosures';
import SubmitDealForReview from 'routes/fundDeals/CreateDeal/SubmitForReview';

import ProtectedRoute from 'components/ProtectedRoute';

import FundDealCommitments from './DealInformation/Commitments';
import ConsentInvite from './DealInformation/ConsentInvite';
import FundDealInformation from './DealInformation/Information';
import ManageDealForFund from './DealInformation/Manage';
import FundClosings from './FundClosings';
import FundDealPage from './FundDeals/FundDeal';
import FundDeals from './FundInvestments/DealsOfFunds';
import FundInvestments from './FundInvestments/index';
import FundNetwork from './FundNetwork';
import FundPortfolio from './FundPortfolio';
import FundPosts from './FundPosts';
import FundSettings from './FundSettings';
import SuspendedFund from './SuspendedFund';

const routes = [
  {
    path: '/fund-dashboard/:fundId',
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <FundPortfolio />
          </ProtectedRoute>
        ),
      },
      {
        path: 'network',
        element: (
          <ProtectedRoute>
            <FundNetwork />
          </ProtectedRoute>
        ),
      },
      {
        path: 'deals-of-fund',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <FundDeals />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId',
            element: (
              <ProtectedRoute>
                <FundDealPage />
              </ProtectedRoute>
            ),
            children: [
              {
                index: true,
                element: <Navigate replace to="manage" />,
              },
              {
                path: 'manage',
                element: (
                  <ProtectedRoute>
                    <ManageDealForFund />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'consent-invite',
                element: (
                  <ProtectedRoute>
                    <ConsentInvite />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'information',
                element: (
                  <ProtectedRoute>
                    <FundDealInformation />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'commitments',
                element: (
                  <ProtectedRoute>
                    <FundDealCommitments />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
      {
        path: 'partners',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <FundClosings />
              </ProtectedRoute>
            ),
          },
          {
            path: 'invites',
            element: (
              <ProtectedRoute>
                <FundNetwork />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'investments',
        element: (
          <ProtectedRoute>
            <FundInvestments />
          </ProtectedRoute>
        ),
      },
      {
        path: 'settings',
        element: (
          <ProtectedRoute>
            <FundSettings />
          </ProtectedRoute>
        ),
      },
      {
        path: 'posts',
        element: (
          <ProtectedRoute>
            <FundPosts />
          </ProtectedRoute>
        ),
      },
      {
        path: 'create-deal',
        element: (
          <ProtectedRoute>
            <CreateDeal />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <BasicInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/basic-information',
            element: (
              <ProtectedRoute>
                <BasicInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/external-investors',
            element: (
              <ProtectedRoute>
                <ExternalInvestors />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/company-information',
            element: (
              <ProtectedRoute>
                <CompanyInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/memo',
            element: (
              <ProtectedRoute>
                <Memo />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/risks-and-disclosures',
            element: (
              <ProtectedRoute>
                <RisksDisclosures />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/carry-recipients',
            element: (
              <ProtectedRoute>
                <CarryRecipients />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/e-sign-submit',
            element: (
              <ProtectedRoute>
                <SubmitDealForReview />
              </ProtectedRoute>
            ),
          },
          {
            path: ':dealId/under-review',
            element: (
              <ProtectedRoute>
                <DealUnderReview />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'suspended',
        element: <SuspendedFund />,
      },
    ],
  },
];

export default routes;
